import { Dispatch, SetStateAction } from 'react';
import { getSupportAppDownloadUrl } from './getSupportAppDownloadUrl';

export function generateSupportAppLink(
  setShowModal: Dispatch<SetStateAction<boolean>>,
  mobileOS: string | undefined
) {
  !mobileOS
    ? setShowModal(true)
    : window.open(getSupportAppDownloadUrl(), '_blank', 'noreferrer');
}
